interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SHP";
};

const SHP: Currency = Object.freeze({
  "displayName": "Saint Helena Pound",
  "numericCode": 654,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SHP",
  "symbol": "£"
});

export { SHP };
